import React from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Link as StyledLink,
} from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { ConfigContext } from '../../config/index';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    background: theme.palette.background.default,
  },
  paper: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    fontSize: '1.4em',
  },
  subtitle: {
    fontSize: '1em',
  },
}));

export default function Home() {
  const classes = useStyles();
  const config = React.useContext(ConfigContext);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {config.siteTitle} | {config.siteName}
        </title>
        <link rel="canonical" href={config.siteUrl} />
      </Helmet>
      <Container maxWidth="lg" className="root">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Typography variant="h5">Home</Typography>
            </Paper>
            <Paper className={classes.paper}>
              <Typography variant="h6">Electronic Music Calendars</Typography>
              {config.regions.map(({ name, name2, id, slug }) => (
                <div key={id} className={classes.card}>
                  <Typography
                    variant="h5"
                    component="h2"
                    className={classes.title}
                  >
                    <StyledLink to={`/events/${slug}`} component={Link}>
                      {name}
                    </StyledLink>
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h3"
                    className={classes.subtitle}
                  >
                    {name2}
                  </Typography>
                </div>
              ))}
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
